import React from 'react';
import { MultiCombobox } from '~/components/uie-fix/MultiCombobox';
import { useFilterField } from '../../hooks/useFilterField';
import { useStaticProps } from '../../context';

export const AgencyFilter = () => {
  const agencyFilter = useFilterField('agencyId', 'PrimaryFilter');
  const {
    referenceData: { agencies },
  } = useStaticProps();

  return (
    <MultiCombobox
      value={agencyFilter.value}
      aria-label="Agency"
      placeholder="Agency"
      onChange={(selectedItems) => agencyFilter.setValue(selectedItems.filter((s) => !!s.trim()))}
      placeholderVariant="indicator"
    >
      {Object.entries(agencies).map(([id, { name }]) => (
        <MultiCombobox.Option label={name} value={id} key={id} />
      ))}
    </MultiCombobox>
  );
};
